import { styled as o } from "@mui/material";
import r from "../../share/apeiron/ApeironBlueButton.js";
import { useTranslation as n } from "react-i18next";
import { jsx as m } from "react/jsx-runtime";
const i = o(r)`
  width: 120px;
  height: 36px;
`, f = () => {
  const {
    t
  } = n();
  return /* @__PURE__ */ m(i, {
    type: "submit",
    children: t("common.confirm")
  });
};
export {
  f as default
};
//# sourceMappingURL=ConfirmButton.js.map
